import { Get, Post, WPGet } from "../api";
import messages from "../static/messages";

export const FETCH_DEBTS_RESULT = "FETCH_DEBTS_RESULT";
export const FETCH_INVOICES_RESULT = "FETCH_INVOICES_RESULT";
export const FETCH_PLAN_RESULT = "FETCH_PLAN_RESULT";
export const CREATE_PLAN_RESULT = "CREATE_PLAN_RESULT";
export const FETCH_WP_CONTENT_RESULT = "FETCH_WP_CONTENT_RESULT";
export const LOCALE_SET = "LOCALE_SET";
export const DUE_SET = "DUE_SET";
export const MOVE_DUE_RESULT = "MOVE_DUE_RESULT";
export const MOVE_DUE_ERROR = "MOVE_DUE_ERROR";
export const PAY_NOW_RESULT = "PAY_NOW_RESULT";
export const LOGIN = "LOGIN_RESULT";
export const VERIFY_PAYMENT_RESULT = "VERIFY_PAYMENT_RESULT";
export const UPDATE_USER = "UPDATE_USER";
export const SET_USER = "SET_USER";
export const API_ERROR = "API_ERROR";
export const LOGOUT = "LOGOUT";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const ANALYTICS_DUE = "ANALYTICS_DUE";
export const PAYMENT_DONE = "PAYMENT_DONE";
export const FETCH_ORDER_INFO_RESULT  = "FETCH_ORDER_INFO_RESULT";
export const FETCH_ORDER_INFO_FETCHING = "FETCH_ORDER_INFO_FETCHING";
export const FETCH_JWKS_RESULT = "FETCH_JWKS_RESULT";


export const fetchJwks = () => Get("FETCH_JWKS", `jwks/`);
export const fetchDebts = () => Get("FETCH_DEBTS", `debts/`);
export const fetchInvoices = () => Get("FETCH_INVOICES", `invoices/`);
export const fetchPlan = (id, parts, due) =>
  Get("FETCH_PLAN", `plan/${id}/${parts}/${due}`);
export const fetchWPContent = id => WPGet("FETCH_WP_CONTENT", id);
export const fetchPDFFile = path => Post("FETCH_PDF_FILE", `file/`, path);
export const updateUser = user => Post("UPDATE_USER", "user/", user);
export const backendLogin = pin => Post("LOGIN", "login/", { pin });
export const payNow = payment_id => Post("PAY_NOW", `pay/`, { payment_id });
export const fetchOrderInfo = orderInfo => {
  return Get("FETCH_ORDER_INFO", "orders/", {
    order_number: orderInfo.order_number,
    amount: orderInfo.amount,
    customer_id: orderInfo.customer_id
  })
};
export const verifyPayment = data =>
  Post("VERIFY_PAYMENT", "verify/", { data });
export const createPlan = (id, parts, due) =>
  Post("CREATE_PLAN", "plan/", { id: id, parts: parts, due: due });

export const localeSet = lang => ({
  type: LOCALE_SET,
  lang,
  messages: messages[lang]
});

export const setLocale = lang => dispatch => {
  dispatch(localeSet(lang));
};

export function logout() {
  //console.log("logout action");
  return { type: LOGOUT };
}

export const setDue = due => ({
  type: DUE_SET,
  payload: due
});

export const analyticsDue = (move_sum, move_days) => ({
  type: ANALYTICS_DUE,
  payload: { move_sum, move_days }
});

export const paymentDone = data => ({
  type: PAYMENT_DONE,
  payload: { data }
});

export const moveDue = (id, days) =>
  Post("MOVE_DUE", "movedue/", { lasku_id: id, paivat: days });

export const login = id => ({
  type: LOGIN,
  payload: id
});

export const setUser = user => ({
  type: SET_USER,
  payload: user
});


// WEBPACK FOOTER //
// ./src/actions/index.js